import styled, { css } from 'styled-components';
import { respondTo } from 'components/styles/_respondTo';
import { fontFamily } from '../../styles/_variables';

export const Wrapper = styled.div`
  padding: 10px 20px 20px 20px;
  ${respondTo.desktop`
    margin-top: 30px;
  `}
  ${respondTo.mobile`
    padding: 20px 20px 0 20px;
  `}
`;

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

export const LogoutWrapper = styled.div`
  display: block;
  ${respondTo.mobile`
    display: none;
  `}
`;

export const SubTitle = styled.h2`
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 24px;
  font-weight: bold;
  color: #636262;
  margin-top: 20px;
  flex: 1;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${respondTo.desktop`
    font-size: 36px;
    font-weight: 600;
    line-height: 1.19;
    letter-spacing: -0.6px;
    margin-top: 20px;
    flex: unset;
  `}
`;

export const Title = styled.h4`
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 10px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.4;
  letter-spacing: normal;
  color: #636262;
`;

export const ConfigButton = styled.button`
  border-radius: 8px;
  background-color: #ff7828;
  width: 53px;
  height: 20px;
  font-family: ${fontFamily.primary};
  font-size: 10px;
  font-weight: bold;
  letter-spacing: -0.17px;
  text-align: center;
  color: #ffffff;
  margin-left: 20px;
  line-height: 20px;
  border: none;
  cursor: pointer;
  transition: 0.3s ease all;

  &:hover {
    background-color: #ff9b1f;
  }

  ${({ openedList }) =>
    openedList &&
    css`
      background-color: #d6d6d6;
      width: 77px;
      &:hover {
        background-color: #d6d6d6;
      }
    `}
`;
